import { useContext, useMemo } from "react";
import { CompanyWorkflowSettingNavigation } from "~/components/common/company_workflow_settings/CompanyWorkflowSettingNavigation";
import { ConstructionClientNavigation } from "~/components/common/constructions/navigation/ConstructionClientNavigation";
import { ReportImageNavigation } from "~/components/common/reports/navigation/ReportImageNavigation";
import { OwnStatusHandleButtons } from "~/components/common/statuses/OwnStatusHandleButtons";
import { UploadFileNavigation } from "~/components/common/upload_files/UploadFileNavigation";
import { useDealContext } from "~/context/DealContext";
import { useDealEstimationHistories } from "~/hooks/deals/useDealEstimationHistories";
import { useDealEstimations } from "~/hooks/deals/useDealEstimations";
import { useDealInspectionReportImages } from "~/hooks/deals/useDealInspectionReportImages";
import { WORKFLOW_REQUIREMENT_TYPE } from "~/models/CompanyWorkflowSetting";
import { matchDealType } from "~/models/Deal";
import { navigationTitle } from "~/models/DealReportImage";
import type { DealUploadFile } from "~/models/DealUploadFile";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import {
	OWN_IN_CONSTRUCTION,
	OWN_IN_ESTIMATION,
	OWN_SEND_ESTIMATE,
	ownStatusMovingValidation
} from "~/models/Status";
import { PATH as INSPECTION_REPORT_PATH } from "~/pages/deals/[id]/inspection_reports";
import { getFilePath as getClientFilePath } from "~/utils/api/deals/DealUploadedFile";
import Styles from "./statuses.module.scss";

export const OwnSendEstimate: React.FC = () => {
	const deal = useDealContext();
	const { id } = deal;
	const { data: dealEstimationContext } = useDealEstimations().index(id);
	const { data: dealEstimationHistoryContext } =
		useDealEstimationHistories().index(id);
	const { data: reportImages } = useDealInspectionReportImages().index(id);
	const account = useContext(ItandiAccountContext);
	const statusDisabled = useMemo(
		() => !ownStatusMovingValidation[OWN_SEND_ESTIMATE](account),
		[account]
	);
	if (dealEstimationContext === null || dealEstimationHistoryContext === null) {
		return null;
	}
	const handleGetMemorandumFilePath = (file: DealUploadFile): string =>
		getClientFilePath(id, file);
	return (
		<div>
			<h3 className={Styles.Title}>
				{`${
					matchDealType(deal, "restoration") ? "退去" : ""
				}立会が完了しました`}
			</h3>
			{reportImages !== null && (
				<ReportImageNavigation
					detailPageButtonLabel="画像確認画面"
					detailPagePath={INSPECTION_REPORT_PATH(id)}
					reportImages={reportImages}
					title={navigationTitle(deal)}
				/>
			)}
			<ConstructionClientNavigation title="見積りを確認してください" />
			<CompanyWorkflowSettingNavigation
				dealId={id}
				targetScreens={[
					WORKFLOW_REQUIREMENT_TYPE.ESTIMATION,
					WORKFLOW_REQUIREMENT_TYPE.OWNER_BILLING
				]}
			/>
			{deal.dealMemorandumFiles.length > 0 && (
				<UploadFileNavigation
					deal={deal}
					files={deal.dealMemorandumFiles}
					fileType="賃借人同意書"
					handleGetFilePath={handleGetMemorandumFilePath}
					title="賃借人同意書を確認してください"
				/>
			)}
			<OwnStatusHandleButtons
				allowPartiallyFinish
				backwardDisabled={statusDisabled}
				forwardDisabled={statusDisabled}
				nextStatusId={OWN_IN_CONSTRUCTION}
				prevStatusId={OWN_IN_ESTIMATION}
			/>
		</div>
	);
};
